import React , {useState , useEffect}from 'react';
import instance from './axios';
import "./Row.css";
import YouTube from 'react-youtube';
import movieTrailer from 'movie-trailer';

function Row({ title, fetchUrl, isLargeRow }) {

    const [movies, setMovies] = useState([]);
    const base_URL = 'https://image.tmdb.org/t/p/original/';
    const [trailerUrl, setTrailerUrl] = useState("");
   

    useEffect( ()=> {
        async function fetchData(){
            const request = await instance.get(fetchUrl);
            setMovies(request.data.results)
            
        }
        fetchData();
    }, [fetchUrl]);

    const opts = {
        height: '390',
        width: '100%',
        playerVars: {
            // https://developers.google.com/youtube/player_parameters
            autoplay: 1
        }
    }
    const handelClick = (movie) => {
        if (trailerUrl) {
            setTrailerUrl("");
        } else {
            movieTrailer(movie?.name || movie?.original_title ||"")
                .then(url => {
                    const urlParams = new URLSearchParams(new URL(url).search);
                    setTrailerUrl(urlParams.get('v'));
                
                }).catch(error => console.log(error));
        }
    }
  
  return (
    <div className='row'>
        <h2 className='row_title'>{title}</h2>
        
        <div className="row__posters">
        
            {movies.map( (movie) => (
                <img key={movie.id}
                    onClick={ () => handelClick(movie)}
                    className={`row__poster ${isLargeRow && "row_posterlarge"}`}
                    src={`${base_URL}${isLargeRow ? movie.poster_path : movie.backdrop_path}`}
                    alt={movie.original_title}>
                    </img>
            )
                
                
            )}
        </div>
    {trailerUrl && <YouTube videoId={trailerUrl} opts={opts} />  } 
    </div>
  )
}
export default Row;
